/*
   This function will return an dictionary 
   which indicates which column will have an extra item
   {1:false,2:true,3:false}
*/
const calculateIndexMap2 = (extra, middle) => {
    if (extra <= 0) return {};
    let map = {};
    middle=1;
    
    let right = middle + 1;
    map[middle] = true;
    extra = extra - 1;
    while (extra) {
      map[right] = true;
      extra = extra - 1;
      right = right + 1;
      
    }
    return map;
  };

  export default calculateIndexMap2